import React from "react";
import { Link } from "react-router-dom";
import InputField from "components/fields/InputField";
import { authApi } from "api/endpoints";

export default function ForgotPassword() {
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [done, setDone] = React.useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const { res, data } = await authApi.forgotPassword({
        email: email.trim(),
      });
      if (!res.ok) {
        const msg =
          data?.error ||
          data?.message ||
          "No se pudo procesar la solicitud. Intentá de nuevo.";
        throw new Error(msg);
      }
      setDone(true);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "No se pudo enviar la solicitud.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
        <div className="mt-[10vh] w-full max-w-full md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Revisá tu correo
          </h4>
          <p className="mb-6 ml-1 text-base leading-relaxed text-gray-600 dark:text-gray-300">
            Si existe una cuenta asociada a{" "}
            <strong className="text-navy-700 dark:text-white">{email}</strong>,
            te enviamos un enlace para restablecer la contraseña. El enlace
            vence en 1 hora.
          </p>
          <p className="mb-8 ml-1 text-sm text-gray-500 dark:text-gray-400">
            ¿No ves el mensaje? Revisá spam o correo no deseado.
          </p>
          <Link
            to="/auth/sign-in"
            className="text-sm font-semibold text-brand-500 hover:text-brand-600 dark:text-brand-300"
          >
            Volver a iniciar sesión
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Recuperar contraseña
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600 dark:text-gray-300">
          Ingresá el correo de tu cuenta. Si está registrado, recibirás un
          enlace para elegir una nueva contraseña.
        </p>

        <form onSubmit={handleSubmit} className="w-full">
          {error ? (
            <p
              className="mb-3 ml-1 rounded-lg border border-red-400/50 bg-red-50 px-3 py-2 text-sm text-red-700 dark:border-red-500/40 dark:bg-red-950/40 dark:text-red-200"
              role="alert"
            >
              {error}
            </p>
          ) : null}

          <InputField
            variant="auth"
            extra="mb-3"
            label="Correo *"
            placeholder="tu@empresa.cl"
            id="forgot-email"
            type="email"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
            autoComplete="email"
            required
          />

          <button
            type="submit"
            disabled={submitting}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {submitting ? "Enviando…" : "Enviar enlace"}
          </button>
        </form>

        <div className="mt-6">
          <Link
            to="/auth/sign-in"
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-brand-300"
          >
            ← Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
